// can be removed after upgrading to newer version of typescript that can import json files.
/* eslint-disable global-require */

export const environment = {
    production: true,
    envName: "prod",
    apiBase: "https://production.api.viatim.nl/api/v1",
    version: require("../../package.json").version,
};
